export default "__VITE_ASSET__nyHO9z7V__"